import * as React from 'react';
import { inject } from 'mobx-react';
import { observer } from 'mobx-react-lite';
import { ViewerStores } from '../stores';
import { STORE_DOCUMENT_VIEW } from '../constants';
import DocumentViewer from '../components/DocumentViewer';

export interface DocumenViewerPageProps {
    match: {
        params: {
            path: string;
        };
    };
    location: {
        search: string;
    };
}

type Props = ViewerStores & DocumenViewerPageProps;

const DocumentViewerPage: React.FC<Props> = ({ documentViewUI: store, match, location }) => {
    if (!store) {
        return null;
    }

    const queryParams = new URLSearchParams(location.search);
    const fileName = queryParams.get('fileName') || undefined;

    return <DocumentViewer store={store} path={match.params.path} fileName={fileName} />;
};

export default inject(STORE_DOCUMENT_VIEW)(observer(DocumentViewerPage));
